import type { ReactNode } from 'react';
import { PdfViewer } from '@/components/quote-editor/PdfViewer';

interface DocumentSplitProps {
  documentUrl: string | null | undefined;
  documentMimeType: string | null | undefined;
  children: ReactNode;
}

export default function DocumentSplit({ documentUrl, documentMimeType, children }: DocumentSplitProps) {
  if (documentUrl && documentMimeType) {
    return (
      <div className="flex h-[70vh] border-t">
        <div className="w-1/2 min-w-0 border-r bg-[var(--color-surface-container-low)]">
          <PdfViewer fileUrl={`/api/files/${documentUrl}`} mimeType={documentMimeType} />
        </div>
        <div className="w-1/2 min-w-0 overflow-y-auto">{children}</div>
      </div>
    );
  }
  return <>{children}</>;
}
